module.exports = __webpack_public_path__ + "static/media/elevator.c87c50d8.png";